import { type JSX } from 'react/jsx-runtime';

export const JpdPrioritizationLightIcon = (): JSX.Element => (
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="20" height="20" rx="4" fill="#eed7fc" />
		<path d="M16.635 9.804H6.487v4.958h10.148z" fill="#bf63f3" />
		<path d="M13.481 6.724H3.333v4.959h10.148z" fill="#fca700" />
		<path d="M13.481 9.804H6.487v1.879h6.994z" fill="#ae2a19" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m16.004 11.595-2.185 2.186-1.13-1.16.488-.474.65.667 1.698-1.698.481.481z"
			fill="#fff"
		/>
	</svg>
);
